import { FC } from 'react';
// components
import EditBaseCoating from 'components/main/BaseCoating/Edit';

const BaseCoating: FC = () => <EditBaseCoating />;

export default BaseCoating;
